import { closeIcon } from "../../assets/icons";
import Button from "../atoms/button";

// Functional component for Information Governance
const ModalPopup = (props: any) => {

    const HasFormSupport = (props: any) => {
        if (!props.isForm) {
            return props.children;
        }

        return <form
            className="form-wrapper"
            onSubmit={(e) => props.onSubmit(e)}
        >
            {props.children}
        </form>
    }

    const Footer = () => {
        if (!props.isFooter) {
            return null;
        }

        return (<div className="modal-footer" >
            <Button
                key={"negativeActionButton"}
                title={props.footer.negativeActionButton.title || "Cancel"}
                className="button cancel-button"
                type="button"
                onClick={() => props.onSubmit("", null)}
            />
            <Button
                key={"positiveActionButton"}
                title={props.footer.positiveActionButton.title || "Save"}
                name={props.footerbutton.name}
                className={"button save-button"}
                type="submit"
            />
        </div>)
    }


    return (<div className="modal-popup">
        <div
            className="modal fade show"
            id={props.id}
            role="dialog"
            aria-labelledby={props.id}
            aria-hidden="true"
        >
            <div className="modal-dialog" role="document" style={{ width: "30%" }}>
                <div className="modal-content">
                    {/* POPUP HEADER */}
                    <div className="modal-header">
                        <h5 className="modal-title">{props.title}</h5>
                        <button className="btn btn-transparent close" onClick={() => props.onSubmit("", null)}>
                            <img src={closeIcon} alt="close" />
                        </button>
                    </div>
                    <HasFormSupport isForm={props.isForm} onSubmit={props.onSubmit}>
                        {/* POPUP BODY */}
                        <div className="modal-body">
                            {props.children}
                        </div>
                        <Footer />
                    </HasFormSupport>
                </div>
            </div>
        </div>
    </div>)
};

export default ModalPopup;